import { AppBar, Dialog, IconButton, Slide, Toolbar } from "@mui/material";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { TransitionProps } from "@mui/material/transitions";
import React from "react";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';


const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const prettifyXml = (sourceXml: string) => {
    try {
        let xmlDoc = new DOMParser().parseFromString(sourceXml, 'application/xml');
        let xsltDoc = new DOMParser().parseFromString([
            // describes how we want to modify the XML - indent everything
            '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
            '  <xsl:strip-space elements="*"/>',
            '  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
            '    <xsl:value-of select="normalize-space(.)"/>',
            '  </xsl:template>',
            '  <xsl:template match="node()|@*">',
            '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
            '  </xsl:template>',
            '  <xsl:output indent="yes"/>',
            '</xsl:stylesheet>',
        ].join('\n'), 'application/xml');

        let xsltProcessor = new XSLTProcessor();
        xsltProcessor.importStylesheet(xsltDoc);
        let resultDoc = xsltProcessor.transformToDocument(xmlDoc);
        return new XMLSerializer().serializeToString(resultDoc);
    } catch (e : any) {
        return sourceXml;
    }
};

const DebugXMLInvoice = (props: any) => {
    return (
        <Dialog
            fullScreen
            open={props.open}
            onClose={props.onClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: "relative" }}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={props.onClose}
                        aria-label="close"
                    >
                        <CloseRoundedIcon/>
                    </IconButton>
                </Toolbar>
            </AppBar>

            <SyntaxHighlighter showLineNumbers={true} lineProps={{ style: { wordBreak: 'break-all', whiteSpace: 'pre-wrap' } }}
                               wrapLines={true} language="xml">{prettifyXml(props.xml)}</SyntaxHighlighter>
        </Dialog>
    );
};

export default DebugXMLInvoice;
